{
  "_meta": {
    "idioma": "en",
    "nombre": "English",
    "predeterminado": false,
    "_nota": "Stable codes and UI text only. Provider literals are NEVER translated."
  },
  "app": {
    "nombre": "Freight Bridge",
    "suite": "AGS · Logistics suite",
    "cargando": "Loading…",
    "sinResultados": "No results",
    "idioma": "Language",
    "veCosto": "sees costs",
    "noVeCosto": "does not see costs",
    "reintentar": "Retry",
    "cerrar": "Close",
    "salir": "Sign out",
    "recorte": "Showing the {n} most recent, and there are more. Narrow the search or the filters: what is not listed here still exists.",
    "rutaRota": "The address “{ruta}” does not exist.",
    "rutaRotaDonde": "Nothing moved: you are still in {zona}.",
    "rutaRotaCerrar": "Got it"
  },
  "modo": {
    "FCL": "Full container (FCL)",
    "LCL": "Consolidated cargo (LCL)",
    "AEREO": "Air",
    "PROYECTO": "Project",
    "TERRESTRE": "Road",
    "FLUVIAL": "Inland waterway",
    "FERROVIARIO": "Rail"
  },
  "tramo": {
    "ORIGEN": "Origin",
    "FLETE": "Freight",
    "DESTINO": "Destination",
    "OTRO": "Other"
  },
  "inclusion": {
    "ADICIONAL": "Additional",
    "INCLUIDO": "Included in freight",
    "EXCLUIDO_DECLARADO": "Declared excluded"
  },
  "direccion": {
    "COSTO": "Cost",
    "INGRESO": "Revenue"
  },
  "terminoEntrega": {
    "CY_CY": "CY / CY",
    "CY_DOOR": "CY / Door",
    "DOOR_CY": "Door / CY",
    "DOOR_DOOR": "Door / Door",
    "NO_DECLARADO": "Not declared"
  },
  "alcance": {
    "ALL_IN": "All-in",
    "SOLO_FLETE": "Freight only",
    "FLETE_MAS_ORIGEN": "Freight plus origin",
    "NO_DECLARADO": "Not declared"
  },
  "estadoVigencia": {
    "VIGENTE": "Valid",
    "VENCIDA": "Expired",
    "VENCIDA_POR_DEFECTO": "No validity declared",
    "ZARPADA": "Vessel sailed",
    "FUTURA": "Future"
  },
  "estadoCotizacion": {
    "BORRADOR": "Draft",
    "ENVIADA": "Sent",
    "APROBACION_PENDIENTE": "Pending approval",
    "ACEPTADA": "Accepted",
    "RECHAZADA": "Rejected",
    "VENCIDA": "Expired"
  },
  "estadoEmbarque": {
    "RESERVADO": "Booked",
    "EN_ORIGEN": "At origin",
    "EN_TRANSITO": "In transit",
    "EN_DESTINO": "At destination",
    "ENTREGADO": "Delivered",
    "CERRADO": "Closed"
  },
  "carrier": {
    "titulo": "Carrier",
    "IDENTIFICADO": "Carrier not named in the catalogue",
    "CODIGO_PENDIENTE": "Carrier not disclosed",
    "ENMASCARADO": "Carrier masked",
    "NO_DECLARADO": "Carrier not declared",
    "contrato": "Contract",
    "servicio": "Service",
    "MULTIPLE": "Two airlines operate this rate and the supplier does not say which"
  },
  "estadoCarrier": {
    "IDENTIFICADO": "Identified",
    "CODIGO_PENDIENTE": "Key pending",
    "ENMASCARADO": "Masked",
    "NO_DECLARADO": "Not declared",
    "MULTIPLE": "Two airlines"
  },
  "busqueda": {
    "titulo": "Search valid rates",
    "pol": "Port of loading (POL)",
    "pod": "Port of discharge (POD)",
    "modo": "Mode",
    "equipo": "Equipment",
    "fechaEmbarque": "Shipment date",
    "buscar": "Search",
    "buscando": "Searching…",
    "pais": "Country",
    "sinPais": "No country",
    "cambiarPais": "change",
    "escribeParaBuscar": "Type two or more letters",
    "aliasSinConfirmar": "Unconfirmed alias",
    "deReferencia": "reference",
    "deReferenciaDetalle": "From the worldwide UN/LOCODE catalogue, not from our own: no rate is loaded against this point today.",
    "hayMas": "More results — keep typing",
    "campoObligatorio": "This field is required",
    "totalResultados": "{n} rates",
    "nadaEncontrado": "No valid rate for this route, equipment and date.",
    "sinCostoCatalogo": "Your user does not see costs: every rate shows its full terms, but the amounts do not come from the server.",
    "porVia": "resolved by",
    "aol": "Origin airport (AOL)",
    "aod": "Destination airport (AOD)",
    "pesoKg": "Actual weight (kg)",
    "pesoKgPista": "What the scale reads. It is compared with the volumetric weight and the larger one is charged.",
    "volumenM3": "Volume (m³)",
    "volumenM3Pista": "Required: without it there is no way to know how many kilos are charged.",
    "bultos": "Pieces",
    "bultosPista": "How many pieces. It does not change the price: it checks each rate’s per-piece limits.",
    "opcional": "optional",
    "nBultos": {
      "uno": "1 piece",
      "otro": "{n} pieces"
    },
    "m3": "m³",
    "escribeParaBuscarAereo": "Type the IATA code or two letters of the name"
  },
  "desambiguacion": {
    "titulo": "You have to choose before searching",
    "NOMBRE_AMBIGUO": "Ambiguous name",
    "ALIAS_SIN_CONFIRMAR": "Unconfirmed alias",
    "ALIAS_MULTIPLE": "The alias groups several equipment types",
    "SIN_RESOLVER": "Does not resolve against the catalogue",
    "TIPO_INCOMPATIBLE": "Not valid for this mode",
    "elegir": "Use this one",
    "sinOpciones": "There is nothing to propose: fix the value and search again."
  },
  "grupo": {
    "titulo": "Scope {alcance} · Delivery {termino}",
    "comparabilidad": "Totals are only comparable within this group.",
    "advertencia": "Scope warning"
  },
  "resultado": {
    "proveedor": "Provider",
    "proveedorNoIdentificado": "Provider not identified",
    "total": "Total",
    "sinCosto": "Your user does not see costs",
    "ingreso": "Provider revenue",
    "neto": "Net",
    "cargos": "Charges",
    "cargosFuera": "Outside the total",
    "diasLibres": "Free days",
    "demora": "demurrage",
    "detencion": "detention",
    "minimo": "negotiated minimum",
    "dias": "days",
    "tramo": "Leg",
    "acciones": "Actions",
    "transito": "Transit",
    "noDeclarado": "Not declared",
    "vigencia": "Validity",
    "etd": "ETD",
    "hasta": "until",
    "espacio": "Space",
    "disponible": "available",
    "confianza": "Confidence",
    "notaRevision": "Review note",
    "restriccion": "Cargo restriction",
    "condicionComercial": "Commercial condition",
    "frecuencia": "Frequency",
    "cotizar": "Quote this rate",
    "verDetalle": "Show charges",
    "ocultarDetalle": "Hide charges",
    "condiciones": "Conditions",
    "motivoFuera": "Reason"
  },
  "vacio": {
    "inicial": {
      "titulo": "Search a route to start",
      "explica": "Pick a port of loading, a port of discharge and equipment, then press Search. Only verified and valid rates show up: the catalogue may hold more than you see here."
    },
    "sinResultados": {
      "titulo": "No quotable rate for this search"
    },
    "rutaDesconocida": {
      "titulo": "This route is not in the catalogue",
      "explica": "There is no rate loaded for {ruta} in {modo}, valid or expired.",
      "hacer": "Check both ports are the ones you meant — there are same-named ports in different countries — and if they are, the route has not arrived by email yet."
    },
    "hayTarifas": {
      "uno": "There is 1 rate loaded for {ruta}, but it is not quotable. Why:",
      "otro": "There are {n} rates loaded for {ruta}, but none of them is quotable. Why:"
    },
    "nTarifas": {
      "uno": "1 rate",
      "otro": "{n} rates"
    },
    "sinVigencia": "not declared",
    "causa": {
      "SIN_VERIFICAR": {
        "titulo": "Not verified",
        "explica": {
          "uno": "1 rate is loaded, but nobody has signed off its document. An unverified rate never reaches a quote, however good it is.",
          "otro": "{n} rates are loaded, but nobody has signed off their document. An unverified rate never reaches a quote, however good it is."
        },
        "hacer": "Review them and verify the rate sheet. If it is missing provider data — a coded carrier, for instance — it cannot be verified until that arrives."
      },
      "FUERA_DE_FECHA": {
        "titulo": "Outside the date",
        "explica": {
          "uno": "1 rate is valid today, but its validity does not cover the {fecha} you asked for: it runs to {ultima}.",
          "otro": "{n} rates are valid today, but their validity does not cover the {fecha} you asked for. The latest one runs to {ultima}."
        },
        "hacer": "Change the shipment date, or ask the provider for the next period's rate."
      },
      "EQUIPO_NO_OFRECIDO": {
        "titulo": "Equipment not offered",
        "explica": {
          "uno": "1 rate serves this route and this date, but does not offer {equipo}. The provider marked it as not offered, which is not the same as free.",
          "otro": "{n} rates serve this route and this date, but do not offer {equipo}. The provider marked it as not offered, which is not the same as free."
        },
        "hacer": "Try another equipment type, or ask the provider to price {equipo}."
      },
      "VENCIDA": {
        "titulo": "Expired",
        "explica": {
          "uno": "1 rate has expired: it ran to {ultima}.",
          "otro": "{n} rates have expired. The last one ran to {ultima}."
        },
        "hacer": "Load the provider's new email and verify it. Extending the old one's validity would be writing down that the provider holds a price they never held."
      },
      "SIN_VIGENCIA_DECLARADA": {
        "titulo": "No validity declared",
        "explica": {
          "uno": "1 rate does not say how long it runs. Missing validity counts as expired, not as valid: if it is not known, it is not quoted.",
          "otro": "{n} rates do not say how long they run. Missing validity counts as expired, not as valid: if it is not known, it is not quoted."
        },
        "hacer": "Ask the provider for the validity period and load it."
      },
      "ZARPADA": {
        "titulo": "Vessel already sailed",
        "explica": {
          "uno": "1 rate was tied to a specific sailing that has already left. An ETD rate dies when that vessel sails, not at the end of the week.",
          "otro": "{n} rates were tied to a specific sailing that has already left. An ETD rate dies when that vessel sails, not at the end of the week."
        },
        "hacer": "Ask the provider for the next sailing."
      },
      "FUTURA": {
        "titulo": "Not in force yet",
        "explica": {
          "uno": "1 rate starts later, so it is not quotable today even if it covers the date you asked for.",
          "otro": "{n} rates start later, so they are not quotable today even if they cover the date you asked for."
        },
        "hacer": "Come back when they start. Searching forward is not there yet: it is a known limit of the search, not missing data."
      },
      "CONSULTA_AL_MOMENTO": {
        "titulo": "Price on request",
        "explica": {
          "uno": "1 rate is for reference only: the provider set no price and gives it when booking.",
          "otro": "{n} rates are for reference only: the provider set no price and gives it when booking."
        },
        "hacer": "Ask the provider for a spot quote for this route and date."
      },
      "ESCALON_NO_OFRECIDO": {
        "titulo": "Break not offered",
        "explica": {
          "uno": "1 rate covers the lane and the date, but the weight break for {peso} kg carries the supplier’s slash: they do not offer it. It does not fall back to the neighbouring break, which would charge a price nobody quoted.",
          "otro": "{n} rates cover the lane and the date, but the weight break for {peso} kg carries the supplier’s slash: they do not offer it. It does not fall back to the neighbouring break, which would charge a price nobody quoted."
        },
        "hacer": "Try another weight, or ask the supplier for a price at that break."
      },
      "PESO_FUERA_DE_ESCALONES": {
        "titulo": "Weight outside the breaks",
        "explica": {
          "uno": "1 rate leaves {peso} kg outside its breaks, usually below the first one. It is not extrapolated downwards: that would be inventing a rate.",
          "otro": "{n} rates leave {peso} kg outside their breaks, usually below the first one. It is not extrapolated downwards: that would be inventing a rate."
        },
        "hacer": "Consolidate more cargo, or ask the supplier for a price at that weight."
      },
      "SIN_RELACION_VOLUMETRICA": {
        "titulo": "No volumetric ratio",
        "explica": {
          "uno": "1 rate does not say what ratio converts {volumen} m³ into kilos, so there is no way to know how many kilos are charged. The IATA ratio is not assumed.",
          "otro": "{n} rates do not say what ratio converts {volumen} m³ into kilos, so there is no way to know how many kilos are charged. The IATA ratio is not assumed."
        },
        "hacer": "Ask the supplier for the volumetric ratio of those rates and load it."
      }
    }
  },
  "bandera": {
    "ALCANCE_NO_DECLARADO": "The rate does not declare what it includes: the total is incomplete and not comparable.",
    "TERMINO_ENTREGA_NO_DECLARADO": "It is not known whether the price reaches the yard or the door.",
    "CARGOS_ESTIMADOS": "Some charge came as a range: the total has two bounds.",
    "CARGOS_CONDICIONALES": "Some charges depend on a condition. They are not in the total: read them and decide.",
    "CARGOS_FUERA_DEL_TOTAL": "Some charges could not be priced without knowing the cargo.",
    "CONFIANZA_BAJA": "Extraction confidence below the threshold.",
    "CARRIER_NO_IDENTIFICADO": "Carrier masked, coded or absent.",
    "PROVEEDOR_NO_IDENTIFICADO": "The email did not allow identifying the provider.",
    "MULTIMONEDA": "Charges in more than one currency. They do not add up together.",
    "SIN_FLETE_PARA_EL_EQUIPO": "There is no freight charge for this equipment: it is a route, not a rate.",
    "SUJETA_A_CONFIRMACION": "Subject to provider confirmation.",
    "EMBARGO": "Embargo: the carrier is not accepting cargo on this lane right now. The rate stands as a reference and cannot be booked against.",
    "CONSULTA_CASO_A_CASO": "There is a price but no space commitment: it must be checked per shipment.",
    "SOLO_CARTON": "Cartons only. That is a package-type restriction, not a size one.",
    "ESPACIO_APROXIMADO": "The space date is approximate, not a commitment.",
    "DESPEGA_DE_OTRO_AEROPUERTO": "The flight does not depart from the declared airport: there is a road leg first. Transit time already accounts for it, but pickup and departure are not the same point.",
    "RESTRICCION_POR_BULTO": "This rate limits per-piece size or weight, and it could not be checked against the cargo. Read it before quoting.",
    "BULTO_FUERA_DE_LIMITE": "The declared pieces exceed a limit of this rate. It does not work for this cargo, however cheap it is.",
    "COBRA_PESO_VOLUMETRICO": "More kilos are charged than the cargo weighs: volumetric weight prevails."
  },
  "motivoFuera": {
    "CONDICIONADO": "Depends on a condition",
    "BREAK_DE_PESO": "Price depends on the weight break",
    "BASE_NO_DETERMINABLE": "The basis depends on the cargo",
    "MONEDA_DISTINTA": "In another currency: no FX rate, no conversion",
    "RANGO_SIN_COTAS": "No usable amount",
    "ESCALON_NO_ELEGIDO": "A different weight break: it does not apply at this weight",
    "NO_OFRECIDO": "The supplier does not offer this break",
    "INCLUIDO_EN_FLETE": "Already included in the freight: not added",
    "EXCLUIDO_DECLARADO": "The supplier declares it excluded"
  },
  "cotizador": {
    "titulo": "Quoting",
    "margen": "Margin",
    "costo": "Cost",
    "venta": "Sell",
    "total": "Total",
    "requiereAprobacion": "Approval required: margin below floor",
    "sinRegla": "No applicable rule: check configuration",
    "esEstimado": "Estimated: charge came as a range",
    "tarifaElegida": "Chosen rate",
    "cliente": "Customer",
    "eligeCliente": "Choose a customer",
    "unidades": "Containers",
    "crear": "Create quote",
    "creando": "Creating…",
    "cancelar": "Cancel",
    "folio": "Reference",
    "validaHasta": "Valid until",
    "idiomaDocumento": "Document language",
    "lineas": "Lines",
    "codigo": "Code",
    "concepto": "Item",
    "descripcionLiteral": "Provider description",
    "pisoAplicado": "Floor applied",
    "motivoAprobacion": "Reason",
    "condicionesARevisar": "Conditions you have to review",
    "cargosNoValorados": "Charges that could not be priced",
    "sinCostos": "Your user does not see costs: sell amounts and sell totals are shown.",
    "otra": "Quote another rate",
    "margenPct": "Margin on sell"
  },
  "tarifa": {
    "diasLibresDemora": "Free days (demurrage)",
    "diasLibresDetencion": "Free days (detention)",
    "transito": "Transit",
    "dias": "days",
    "noOfrecido": "Not offered",
    "sinVerificar": "Unverified: not quotable"
  },
  "error": {
    "titulo": "The request could not be completed",
    "red": "Could not reach the API. Is it running with npm run dev:api?",
    "ENTRADA_INVALIDA": "Invalid request",
    "DESAMBIGUACION_REQUERIDA": "You have to choose",
    "SIN_RESOLVER": "Does not resolve against the catalogue",
    "TARIFA_NO_COTIZABLE": "This rate cannot be quoted",
    "EQUIPO_NO_OFRECIDO": "The rate does not offer that equipment",
    "RECURSO_NO_ENCONTRADO": "Not found",
    "RUTA_NO_ENCONTRADA": "Route not found",
    "ERROR_INTERNO": "Internal API error",
    "NO_AUTENTICADO": "Session ended",
    "PROHIBIDO": "You are not allowed to do this",
    "CREDENCIALES_INVALIDAS": "Could not sign in",
    "CAMBIO_DE_CONTRASENA_PENDIENTE": "You still need to choose your password"
  },
  "mapa": {
    "alt": "Route from {pol} to {pod}",
    "ver": "Show the route map",
    "ocultar": "Hide the route map",
    "sinCoordenadas": "The catalogue has no coordinates for {puertos}, so the route is not drawn. Nothing else changes."
  },
  "rfq": {
    "titulo": "Request rates from suppliers",
    "desdeVacio": "Request rates from suppliers",
    "explicaVacio": "If the catalogue has no rate for this lane, ask the suppliers that cover it. The lane you searched is already filled in.",
    "ruta": "Lane",
    "volver": "Back to search",
    "abrirLista": "Requests",
    "remitente": "Send from",
    "remitenteAGS": "AGS",
    "remitenteFREIGHT_BRIDGE": "Freight Bridge (own mailbox, not live yet)",
    "carga": {
      "titulo": "What is being asked for",
      "equipo": "Equipment",
      "unidades": "Quantity",
      "mercancia": "Commodity",
      "mercanciaAyuda": "Sent exactly as you write it, untranslated.",
      "peso": "Gross weight (kg)",
      "volumen": "Volume (m³)",
      "temperatura": "Temperature (°C)",
      "fechaObjetivo": "Target shipment date",
      "requisitos": "Requirements",
      "requisitosAyuda": "Temperature, stacking, dangerous goods, whatever applies.",
      "nota": "Internal note"
    },
    "proveedores": {
      "titulo": "Who gets asked",
      "cubren": "Cover this lane",
      "noCubren": "Do not cover this lane per their declared scope",
      "sinEspecialidad": "No scope declared",
      "explicaNoCubren": "Shown anyway: what we know about their scope may be incomplete, and hiding them would make it impossible to add the one who does run the lane.",
      "sinCorreo": "No email on file: cannot be written to.",
      "ninguno": "No suppliers in the directory.",
      "elegidos": {
        "uno": "1 supplier selected",
        "otro": "{n} suppliers selected"
      },
      "eligeUno": "Select at least one supplier with an email address."
    },
    "coincidencia": {
      "PUERTO": "Exact port",
      "PAIS": "Country",
      "REGION": "Region"
    },
    "crear": "Prepare request",
    "creando": "Preparing…",
    "cancelar": "Cancel",
    "folio": "Reference",
    "correo": {
      "titulo": "Email ready to send",
      "explica": "One per language: each supplier gets it in theirs. Copy it, paste it into your mail client and mark the request as sent.",
      "asunto": "Subject",
      "cuerpo": "Body",
      "para": "To",
      "copiarAsunto": "Copy subject",
      "copiarCuerpo": "Copy body",
      "copiado": "Copied",
      "copiaManual": "The browser blocked copying: the text is selected, press Ctrl+C.",
      "idioma": "Email language"
    },
    "integracion": "Automatic sending through Microsoft Graph is not live yet. Today the API drafts and records; you send the email, which is why «mark as sent» is your statement and not the system's.",
    "marcarEnviada": "Mark as sent",
    "marcando": "Marking…",
    "cerrar": "Close request",
    "destinatarios": "Recipients",
    "enviadoEn": "Sent",
    "sinEnviar": "Not sent",
    "respuestas": {
      "titulo": "Replies",
      "ninguna": "Nobody has replied yet.",
      "proveedor": "Supplier",
      "eligeProveedor": "Select the supplier who replied",
      "registrar": "Record reply",
      "registrando": "Recording…",
      "sinOferta": "Replied that they do not cover the lane or have no offer",
      "nota": "Note",
      "rateSheet": "Rate sheet loaded",
      "sinRateSheet": "No rate sheet yet",
      "respondidaEn": "Replied",
      "soloEnviadas": "The request must be sent before replies can be recorded."
    },
    "lista": {
      "titulo": "Rate requests",
      "vacia": "No open requests.",
      "vaciaTodas": "No requests have been created yet.",
      "verAbiertas": "Open only",
      "verTodas": "All",
      "folio": "Reference",
      "ruta": "Lane",
      "estado": "Status",
      "destinatarios": "Suppliers",
      "sinResponder": "Awaiting reply",
      "creada": "Created",
      "enviada": "Sent",
      "abrir": "Open",
      "nueva": "New request"
    },
    "estado": {
      "BORRADOR": "Draft",
      "ENVIADA": "Sent",
      "CON_RESPUESTAS": "With replies",
      "CERRADA": "Closed"
    }
  },
  "alta": {
    "abrirLista": "Sign-ups",
    "estado": {
      "PENDIENTE": "Pending",
      "APROBADA": "Approved",
      "RECHAZADA": "Rejected"
    },
    "lista": {
      "titulo": "Supplier sign-ups",
      "verTodas": "Show reviewed ones too",
      "cargando": "Loading the queue…",
      "vacia": "Nothing waiting. Whatever comes in through the public form shows up here."
    },
    "col": {
      "folio": "Reference",
      "empresa": "Company",
      "correo": "Email",
      "modos": "Modes",
      "recibida": "Received",
      "estado": "Status"
    },
    "senal": {
      "conocidoCorto": "Already on file",
      "conocido": "That email is already in the directory:",
      "homonimo": "There is already a party with that name:",
      "licencia": "That membership number already belongs to another party:",
      "otras": {
        "uno": "There is 1 more request from the same email waiting.",
        "otro": "There are {n} more requests from the same email waiting."
      }
    },
    "bloque": {
      "dijo": "What they declared",
      "decidir": "What will be created"
    },
    "campo": {
      "empresa": "Company",
      "pais": "Country",
      "sitio": "Website",
      "contacto": "Contact",
      "correo": "Email",
      "telefono": "Phone",
      "idioma": "Language",
      "recibida": "Received",
      "modos": "Modes",
      "trades": "Trades",
      "membresias": "Networks",
      "revisada": "Reviewed",
      "revisor": "Reviewed by",
      "tercero": "Supplier created",
      "motivo": "Reason for rejection"
    },
    "decidir": {
      "enganchar": "Add to the supplier that already exists:",
      "nombre": "Name in the directory",
      "pais": "Country (ISO)",
      "paisAyuda": "Two letters, or blank. The form asks for the country as free text and this is where it gets normalised.",
      "especialidades": "Specialties that will be created",
      "sinEspecialidades": "None: they only described the route in free text. It is kept as the supplier's declared scope and specialties get added by hand.",
      "motivo": "Reason (to reject)",
      "motivoAyuda": "Required to reject. A rejection with no reason is a decision nobody can explain later.",
      "aprobar": "Approve and create",
      "rechazar": "Reject",
      "volver": "Back to the queue"
    },
    "hecho": {
      "creado": "Supplier created:",
      "enganchado": "Completed the supplier that already existed:",
      "especialidades": "Specialties created: {n}. Already there: {repetidas}.",
      "licencias": {
        "uno": "1 membership registered.",
        "otro": "{n} memberships registered."
      },
      "omitida": {
        "SIN_NUMERO": "not registered, it came without a number",
        "YA_REGISTRADA": "not registered, that number already belongs to another party"
      },
      "tradesRaros": "Trades that are not in the catalogue and were not used: {t}"
    }
  },
  "login": {
    "titulo": "Sign in",
    "intro": "Use your company email. If this is your first time, ask an administrator for your initial password.",
    "email": "Email",
    "contrasena": "Password",
    "entrar": "Sign in",
    "entrando": "Signing in…",
    "sinAcceso": "No access, or forgot your password? Ask an administrator: it is changed from inside, not by email.",
    "lema": "International freight rates, space and quotes, in one place.",
    "caducada": "Your session ended. Sign in again to pick up where you left off."
  },
  "usuarios": {
    "abrir": "Users",
    "titulo": "Users",
    "nuevo": "New user",
    "crear": "Create user",
    "cancelar": "Cancel",
    "cargando": "Loading users…",
    "vacia": "There are no users.",
    "elige": "Choose…",
    "tu": "you",
    "activo": "Active",
    "inactivo": "Deactivated",
    "sinClave": "No password",
    "darBaja": "Deactivate",
    "reactivar": "Reactivate",
    "rol": {
      "AGENTE": "Agent",
      "SUPERVISOR": "Supervisor",
      "OPERADOR": "Operator",
      "ADMIN": "Administrator"
    },
    "rolDetalle": {
      "AGENTE": "Quotes and requests prices from suppliers.",
      "SUPERVISOR": "Everything an agent does, plus margin rules and the whole team's quotes.",
      "OPERADOR": "Keeps the catalogue: signs off rates, resolves aliases, reviews supplier applications. Does not quote.",
      "ADMIN": "All of the above, plus adding and deactivating users."
    },
    "veCosto": {
      "si": "Sees costs",
      "no": "No costs"
    },
    "col": {
      "nombre": "Name",
      "email": "Email",
      "rol": "Role",
      "veCosto": "Costs",
      "estado": "Status",
      "sesiones": "Sessions / password",
      "acciones": "Actions"
    },
    "campo": {
      "nombre": "Name",
      "email": "Email",
      "rol": "Role",
      "veCosto": "Sees supplier costs?",
      "contrasena": "Initial password"
    },
    "ayuda": {
      "rol": "The role decides which areas this person reaches. It does not decide whether they see costs: that is the question below, and they are different things.",
      "veCosto": "Decides whether catalogue amounts and quote costs travel to this person. There is no default.",
      "contrasena": "Leave it empty and one is generated: twelve characters with no zeros or Os, meant to be read out loud. It is shown only once. If you type one, at least {n} characters."
    },
    "alta": {
      "titulo": "Add someone"
    },
    "reseteo": {
      "abrir": "Change password",
      "etiqueta": "New password for {nombre}",
      "confirmar": "Change and end their sessions",
      "ayuda": "Leave it empty and one is generated, which you will see only once. Changing it ends every open session of theirs, here and in any other browser, and they will have to choose a new one when they sign in. It cannot be undone."
    },
    "aviso": {
      "creado": "{nombre} can now sign in. Pass the password on through something other than this screen.",
      "baja": "{nombre} is deactivated and their sessions were closed.",
      "reactivado": "{nombre} can sign in again.",
      "reseteada": "Password for {nombre} changed. Sessions closed: {n}."
    },
    "claveTemporal": "temporary password",
    "claveTemporalAyuda": "They have not chosen their own password yet: the one they have was dictated to them. They will change it the first time they sign in.",
    "nSesiones": {
      "uno": "1 open session",
      "otro": "{n} open sessions"
    },
    "contrasenaDesde": "Password since {fecha}",
    "contrasenaSinFecha": "Password with no change date"
  },
  "menu": {
    "titulo": "Areas",
    "alternar": "Open or close the menu"
  },
  "zona": {
    "cotizar": {
      "nombre": "Search and quote",
      "descripcion": "Search live rates by route, mode and equipment, and turn the one you pick into a numbered quote."
    },
    "cotizaciones": {
      "nombre": "Quotes",
      "descripcion": "Quotes already issued, with their number, client and amounts exactly as they went out. Nothing is recalculated."
    },
    "rfq": {
      "nombre": "RFQ requests",
      "descripcion": "Ask suppliers for a price when the catalogue does not cover the route. The API drafts the email; a person sends it."
    },
    "tarifas": {
      "nombre": "Rates",
      "descripcion": "The two catalogue queues: documents waiting to be signed off, and aliases the intake could not resolve.",
      "pendientes": "{n} document(s) ready to sign off"
    },
    "proveedores": {
      "nombre": "Suppliers",
      "descripcion": "The directory an RFQ is sent to, and the queue of those who applied through the public form.",
      "pendientes": "{n} application(s) not yet reviewed"
    },
    "administracion": {
      "nombre": "Administration",
      "descripcion": "Adding and deactivating users, and the margin rules every quote is calculated with."
    },
    "ayuda": {
      "nombre": "Help",
      "descripcion": "What each area does and how to use it. Start here if it is your first day."
    }
  },
  "ayuda": {
    "intro": "This is what your account lets you do, and why the application behaves the way it does. If a zone is missing, your role does not include it: ask an administrator.",
    "indice": "Help sections",
    "buscar": {
      "titulo": "How to search",
      "intro": "The search looks through the catalogue of rates that arrived by email, already normalised. Only rates a colleague has verified and that are valid for the date you ask for come out: the catalogue almost always holds more than you see, and the section below explains why they stay out.",
      "modos": "Ocean and air are two different forms",
      "maritimo": "For ocean you ask for a port of loading, a port of discharge, equipment and a date. The price is per container, so the equipment is what decides which rate applies and with what free time.",
      "aereo": "For air there is no equipment —an air rate does not offer boxes— and instead you give the actual weight and the volume. Both are required: the price is per kilo and the number of kilos charged comes from comparing the two. Pieces are optional and do not change the price; they check each rate’s per-piece limits.",
      "fecha": "The shipment date is never assumed",
      "fechaPorQue": "It is always asked for and never defaulted to today. The date decides which rates are valid, and a rate running to the end of the month is no good for shipping the following week. Assuming it silently would make the list change without anyone having changed anything.",
      "pais": "A port’s country: why you sometimes have to choose",
      "paisPorQue": "Manzanillo exists in both Mexico and Panama. When what you typed identifies more than one place, the search does not run: the options stop on screen and you choose. The most likely one is not taken and no retry happens with the first, because choosing wrong sends the cargo to the wrong continent and nobody finds out until it is late. Picking a suggestion from the autocomplete pins the country; editing the text by hand afterwards clears it, because a country stuck to a port that is no longer what the field says is worse than no country at all.",
      "carga": "What is actually shipping",
      "cargaPorQue": "The nature of the cargo is declared once, below the search, and travels to the quotation and to the RFQ email. Refrigerated asks for a temperature; dangerous asks for an IMO class and a UN number, and the quotation comes out flagged; out-of-gauge asks for the three dimensions. Switching nature does not drag the previous one’s data along: what does not apply does not travel.",
      "noFiltra": "Declaring the cargo does NOT hide rates, and that is deliberate. The only thing it does to the catalogue is put reefer equipment first when the cargo is refrigerated. Discarding rates for dangerous goods, or checking that dimensions fit, needs data the catalogue does not hold, and without it the filter would invent its own criterion: a search that hides rates by a made-up rule is worse than one that shows them all, because what does not appear cannot be reviewed."
    },
    "resultados": {
      "titulo": "How to read the results",
      "intro": "The list is not a list: it is groups, and within each one the rates are ordered by total. The order comes from the server and the screen does not touch it.",
      "grupos": "Why there are several groups and not one table",
      "gruposPorQue": "Rates are grouped by scope and delivery term, and are only comparable within their group. A rate that does not declare what it includes has the lowest total because it is missing charges, not because it is cheaper; and a yard delivery and a door delivery are not the same product. Put in the same column they compare themselves even if nobody ordered them together, so they come out separated and labelled.",
      "avisos": "Each rate’s warnings",
      "avisosPorQue": "Under every row there is a band with what you need to read before deciding. Red ones say the rate cannot be used as it stands; amber ones, that the number beside it may not mean what it looks like. Next to each warning goes the supplier’s own wording, untranslated and uncleaned: the interpretation may be wrong, the original text is not. These are all of them:",
      "costos": "If you cannot see the amounts",
      "costosPorQue": "Cost visibility is a property of your account, not of the rate. When your user does not see costs, the amounts never leave the server: they are not hidden in the page, they did not arrive. What does arrive are the full terms —carrier, transit, free time, scope, validity, and each charge’s code, leg and basis— and the ordering by price stays, because relative order is not the number. A missing field is said in words, never with a zero or an empty cell."
    },
    "peso": {
      "titulo": "The weight that gets charged (air)",
      "intro": "In air freight the kilos invoiced are almost never the ones on the scale. It is the difference that surprises clients most, and the one an agent has to be able to explain without calling anyone.",
      "cual": "The larger of the two is charged",
      "cualPorQue": "Volume is converted into kilos using a ratio that belongs to each rate —6000 cm³/kg is the IATA one, and a “1:500” promotion is 2000— and the larger of that volumetric weight and the actual one is charged. The screen shows all three numbers and says which one won. When a rate does not declare what ratio to convert with, it cannot be quoted: assuming the IATA one would be inventing the price.",
      "ejemplo": "120 kg in 3 m³ pays for 500 kilos at the IATA ratio: volumetric wins. The same cargo on a 1:500 promotion would pay for 1500. No price column changes; what changes is how many kilos multiply.",
      "escalon": "The break decides the price per kilo",
      "escalonPorQue": "An air row carries several prices —+45, +100, +300, +500, +1000— and the chargeable weight picks which one applies. The others do not vanish from the quotation: they come out separately, with their reason, because a break that disappears is indistinguishable from one worth zero. A break’s top is excluded: exactly 500 kilos pays the one starting at 500. And if the supplier left a slash on the break you land in, that rate is no good at that weight: it does not fall back to the neighbouring break, which would charge a price nobody quoted.",
      "bultos": "Per-piece limits",
      "bultosPorQue": "Some rates limit size or weight per piece. If you declare how many pieces there are —and their dimensions, when the cargo is out-of-gauge— the search checks and flags in red the rates that will not take them, with the two numbers they fail by. The rate stays in the list and can still be quoted: the decision is yours. Only what is certain gets flagged: a piece that fits when rotated is not flagged, and neither is an average weight per piece below the cap, even though pieces may be unequal. When there is nothing to compare against, it says so: “could not be checked” is not the same as “it fits”."
    },
    "cotizar": {
      "titulo": "How quoting works and what gets frozen",
      "intro": "Quoting turns a catalogue rate into a document with a reference number. From then on, the amounts are what the company is bound to honour.",
      "congela": "The amounts are frozen",
      "congelaPorQue": "Cost, sell and exchange rate are fixed at the moment the quotation is created. Reading it back tomorrow does not recalculate it, even if the supplier has sent new prices or someone has moved a margin rule: what was sent to the client is what stays written. In air, the full anatomy is frozen too —the weight charged, the ratio the volume was converted with, which break applied and at what price per kilo— so the invoice can still be explained a year later.",
      "noValorados": "Charges that do not enter the total",
      "noValoradosPorQue": "Some charges cannot be turned into a line with an amount, and none of them is dropped silently: they travel with the quotation carrying their original wording and their reason. A charge that disappears without a trace is indistinguishable from a charge worth zero. These are the reasons:",
      "aprobacion": "When it needs approval",
      "aprobacionPorQue": "Margin is validated on the option’s total, not charge by charge. If it falls below the floor, the quotation is still issued but flagged, with the floor that was applied. That verdict is frozen too: a quotation issued with no signature pending does not start needing one because somebody moves the floor afterwards."
    },
    "vacio": {
      "titulo": "When no rate comes out",
      "intro": "Zero results almost never means the lane does not exist. The screen says how many rates are loaded for that lane and why none of them made the list, ordered by what is cheapest to fix. Each reason is fixed differently:"
    },
    "zonas": {
      "titulo": "Where you are",
      "intro": "The zones your account opens. The menu is not the lock: a zone that does not appear is still reachable by typing its address, and what answers then is the API with a 403. The menu exists so as not to show doors that do not open."
    }
  },
  "cotizaciones": {
    "col": {
      "folio": "Number",
      "cliente": "Client",
      "ruta": "Route",
      "estado": "Status",
      "venta": "Sell",
      "creada": "Created",
      "agente": "Agent"
    },
    "abrir": "Open",
    "volver": "Back to the list",
    "tuya": "yours",
    "soloMias": "You are seeing only your own quotes.",
    "deTodos": "You are seeing the whole team's quotes.",
    "vacia": "No quotes yet.",
    "vaciaComo": "They are created from Search and quote: find a route, pick a rate and press Quote.",
    "sinRuta": "Route unavailable",
    "sinTotal": "No total",
    "requiereAprobacion": "Needs approval",
    "enviada": "Sent to client",
    "sinEnviar": "Not sent yet",
    "diasLibres": "Free time",
    "opcionSinEtiqueta": "Option",
    "veredictoAusente": "There is no record of whether this quote needed approval: it was issued before that was stored. It does not mean it did not need any.",
    "conEstimados": "Some charge came as a range and the ceiling was used: the total is an estimate on the high side."
  },
  "tarifas": {
    "intro": "The two queues the search depends on to have anything to return.",
    "firmar": "Sign off",
    "firmando": "Signing off…",
    "firmado": "Document signed off. Rates quotable now: {n}.",
    "sinAsunto": "No subject",
    "sinProveedor": "Supplier not identified",
    "bloqueadoSinMotivo": "Cannot be signed off yet.",
    "sheets": {
      "titulo": "Documents waiting to be signed off",
      "explicacion": "An unverified rate never reaches a quote. Signing off means you have read the document and stand behind it; from then on its rates can be quoted.",
      "vacia": "No documents are waiting to be verified.",
      "documento": "Document",
      "proveedor": "Supplier",
      "estado": "Status",
      "tarifas": "Rates",
      "sinFlete": "No freight",
      "recibido": "Received"
    },
    "alias": {
      "titulo": "Unconfirmed aliases",
      "explicacion": "Words that arrived in an email and the intake could not resolve on its own. Each one blocks the rows that use it.",
      "vacia": "No aliases pending.",
      "comoSeDespacha": "Confirming an alias changes the catalogue permanently and for everyone, so it is not done from here: it goes in as a migration, like any other catalogue change. This queue is for seeing what is pending and what it is blocking.",
      "tipo": "Catalogue",
      "alias": "As it was written",
      "resuelveA": "Points to",
      "proveedor": "Supplier",
      "bloqueadas": "Blocks",
      "aNada": "points to nothing",
      "aRevisar": "acronym with no glossary",
      "confianza": "confidence",
      "global": "all",
      "catalogo": {
        "codigo_cargo": "Charge code",
        "equipo": "Equipment",
        "ubicacion": "Location"
      },
      "estado": {
        "PROPUESTO": "Proposed, waiting to be confirmed",
        "SIN_RESOLVER": "Unresolved"
      },
      "ayuda": {
        "PROPUESTO": "They have a target and only need confirming. Each one confirmed unblocks the rates that used it.",
        "SIN_RESOLVER": "They point to nothing, or to the REVISAR sentinel. Confirming does not fix them: they need a business decision or someone who knows the domain."
      }
    }
  },
  "estadoParseo": {
    "PENDIENTE": "Pending",
    "CLASIFICADO": "Classified",
    "EXTRAIDO": "Extracted",
    "VERIFICADO": "Verified",
    "RECHAZADO": "Rejected",
    "BLOQUEADO_DEPENDENCIA": "Blocked by dependency"
  },
  "proveedores": {
    "pestana": {
      "directorio": "Directory",
      "altas": "Applications"
    },
    "directorio": {
      "titulo": "Supplier directory",
      "intro": "Who we have, with what email, in what language and for what lanes. This is the address book an RFQ goes to."
    },
    "buscar": "Search by name",
    "buscarAccion": "Search",
    "buscarPlaceholder": "Part of the company name",
    "vacio": "The directory is empty.",
    "vacioBusqueda": "No supplier matches “{q}”.",
    "vacioComo": "Suppliers come in through the public application form and its review queue.",
    "irAAltas": "See the application queue",
    "hayMas": "There are more suppliers than fit here. Narrow the search to see them.",
    "noIdentificado": "company not identified",
    "sinCorreo": "no email",
    "sinCorreoAyuda": "No active contact has an email address, so this supplier will not show up when preparing an RFQ.",
    "resumen": "{contactos} contact(s) · {especialidades} specialty(ies) · {sheets} document(s)",
    "ver": "View record",
    "cerrar": "Close record",
    "contactos": "Contacts",
    "sinContactos": "No active contacts.",
    "sinNombre": "No name",
    "sinEmail": "No email",
    "recibeRfq": "receives RFQ",
    "especialidades": "Specialties",
    "sinEspecialidades": "No declared specialty, so it is not proposed when preparing an RFQ for any route."
  },
  "margenes": {
    "titulo": "Margins",
    "intro": "What the sell price of each line is calculated with, and below what margin a quote needs approval. Changing this changes what gets quoted from now on; what is already issued does not move.",
    "verActivas": "Live only",
    "verTodas": "With history",
    "inactiva": "retired",
    "sustituye": "replaces another",
    "editar": "Change",
    "desactivar": "Retire",
    "reactivar": "Reactivate",
    "crear": "Create",
    "cancelar": "Cancel",
    "guardarSustituyendo": "Save as a new version",
    "cualquiera": "Any",
    "aplicaATodo": "Every line",
    "porUnidad": "unit",
    "porMigracion": "by migration",
    "desgloseGlobal": "0 — it narrows no dimension, so it is the one applied when nothing else fits.",
    "dondeAplica": "Where it applies",
    "dondeAplicaAyuda": "Every field you fill narrows the rule and makes it more specific. The most specific of the ones that fit wins; on a tie, the most recent.",
    "reglas": {
      "titulo": "Markup rules",
      "explicacion": "They turn the supplier's cost into a sell price. Listed from most specific to least, which is the order the engine looks at them.",
      "nueva": "New rule",
      "editar": "Change a rule",
      "vacia": "No rules. Without rules the engine quotes at cost and marks every line SIN_REGLA."
    },
    "pisos": {
      "titulo": "Margin floors",
      "explicacion": "Below this margin, the quote comes out flagged as needing approval. Validated on the option total, never line by line.",
      "nuevo": "New floor",
      "editar": "Change a floor",
      "vacio": "No floors. Without one, no quote ever asks for approval."
    },
    "col": {
      "descripcion": "Description",
      "aplicaA": "Applies to",
      "especificidad": "Spec.",
      "tipo": "Type",
      "valor": "Value",
      "minimo": "Minimum",
      "cambio": "Who and when"
    },
    "campo": {
      "descripcion": "Description",
      "tipo": "Calculation type",
      "valor": "Value",
      "modo": "Mode",
      "tramo": "Leg",
      "codigoCargo": "Charge code",
      "cliente": "Client",
      "vigenciaDesde": "Valid from",
      "vigenciaHasta": "Valid until",
      "minPct": "Minimum margin (fraction)",
      "minAbs": "Minimum margin (amount)"
    },
    "ayuda": {
      "descripcionRegla": "It is the only thing that explains this rule to whoever reads it three months from now. Say why, not what: “FCL freight at 5%, agreed with management in August” works; “rule 3” does not.",
      "descripcionPiso": "It appears on screen next to “needs approval”, and it is the only thing that tells the agent what to do.",
      "valorFraccion": "Written as a fraction: 0.08 is 8%.",
      "valorMonto": "Amount per unit, in the rate's currency.",
      "minPct": "Fraction of the sell total: 0.04 is 4%. Leave empty if you only want an amount minimum.",
      "minAbs": "Minimum margin amount, in the sell currency. Optional.",
      "codigoCargo": "A code that already exists in the catalogue (OFR, THC, BAF…). Codes are never invented: if it does not exist, the database rejects the rule.",
      "cliente": "An agreement with a specific client always beats a general policy.",
      "vigencia": "Outside these dates the rule does not apply. Empty “until” means no end date."
    },
    "ayudaTipo": {
      "PORCENTAJE": "sell = cost × (1 + value). The usual markup.",
      "FIJO_UNIDAD": "sell = cost + value × units. A fixed surcharge per container.",
      "VENTA_FIJA": "sell = value × units. Flat price: ignores cost entirely.",
      "MARGEN_OBJETIVO": "sell = cost ÷ (1 − value). The value is the fraction of the sell price you want left as margin.",
      "SIN_MARGEN": "sell = cost. Quoted at cost, with no margin and without looking like an oversight."
    },
    "dim": {
      "cliente": "Client",
      "ruta": "Route",
      "trade": "Trade",
      "cargo": "Charge",
      "tramo": "Leg",
      "modo": "Mode"
    },
    "tipo": {
      "PORCENTAJE": "Percentage",
      "FIJO_UNIDAD": "Fixed per unit",
      "VENTA_FIJA": "Flat sell",
      "MARGEN_OBJETIVO": "Target margin",
      "SIN_MARGEN": "No margin"
    },
    "sustitucion": {
      "titulo": "This does not edit the rule: it creates a new version.",
      "explicacion": "The current rule is retired and a replacement is created. That is deliberate: quotes already issued point at the rule they used, and changing it in place would make their explanation say something else. The full history is kept."
    },
    "aviso": {
      "creada": "Rule created: {d}. It applies from the next quote onwards.",
      "sustituida": "New version saved: {d}. The previous one is retired and still explains the quotes that used it.",
      "creado": "Floor created: {d}.",
      "sustituido": "New version saved: {d}. The previous floor is retired.",
      "activada": "{d} applies again.",
      "desactivada": "{d} is retired. It stops applying from now on."
    }
  },
  "lote": {
    "abrir": "Add several people",
    "titulo": "Add several users",
    "explicacion": "One row per person. Passwords are generated by the system and shown only once, at the end. If anything fails, none are created: fix it and send it again.",
    "anadirFila": "Add another row",
    "quitarFila": "Remove",
    "quitarFilaN": "Remove row {n}",
    "crear": "Create all {n}",
    "creando": "Creating…",
    "faltan": "Rows marked below are missing something. Each person needs a name, an email and an answer to whether they see costs.",
    "unaVez": {
      "titulo": "These passwords are shown only once.",
      "explicacion": "They are not stored anywhere: only their hash is. If you close this screen without copying them, the only way out is changing them one by one."
    },
    "credenciales": {
      "titulo": "{n} user(s) created",
      "contrasena": "Temporary password",
      "laElegiste": "you chose it"
    },
    "copiarTodas": "Copy all",
    "copiado": "Copied. Paste it wherever you are passing it on.",
    "copiaManual": "This browser will not copy on its own. The text is selected below: press Ctrl+C (or Cmd+C).",
    "cerrarYPerder": "I copied them, close",
    "queHacenEllos": "Each person signs in with their email and this password, and the first thing they will see is the screen to choose their own. Until they do, they reach nothing else."
  },
  "cambio": {
    "titulo": "Choose your password",
    "hola": "Hello, {nombre}.",
    "porQue": "The password you just signed in with was given to you by someone else, so someone else knows it. Choose your own before continuing; until then nothing else can be done.",
    "actual": "The password you were given",
    "actualAyuda": "It is asked even though you just typed it: it is the only thing that tells apart whoever signed in from whoever sat down at an unlocked screen.",
    "nueva": "Your new password",
    "nuevaAyuda": "At least {n} characters. No other rules: a short phrase you remember is worth more than something with symbols you end up writing down.",
    "repetida": "Type it again",
    "guardar": "Save and continue",
    "guardando": "Saving…",
    "noCoinciden": "The two new passwords are not the same.",
    "corta": "The new password needs at least {n} characters.",
    "noSoyYo": "This is not me, sign out"
  },
  "carga": {
    "titulo": "What is being shipped?",
    "enCotizacion": "Declared cargo",
    "naturaleza": {
      "GENERAL": "General cargo",
      "REFRIGERADA": "Reefer cargo",
      "PELIGROSA": "Dangerous goods (IMO)",
      "SOBREDIMENSIONADA": "Out of gauge cargo"
    },
    "ayuda": {
      "GENERAL": "The usual. Nothing else to declare.",
      "REFRIGERADA": "You will be asked for the temperature, and reefer equipment moves to the top of the list. No equipment is dropped: a 40NOR is a reefer used as a dry box, and some people pick it on purpose.",
      "PELIGROSA": "You will be asked for the IMO class and UN number. They go on the quote, flagged, and into the supplier email: without them the supplier cannot quote and the cargo is turned away at the gate.",
      "SOBREDIMENSIONADA": "You will be asked for all three dimensions. They go into the supplier email, and the supplier is the one who decides whether it fits."
    },
    "campo": {
      "temperatura": "Temperature (°C)",
      "imoClase": "IMO class",
      "imoUn": "UN number",
      "largo": "Length (cm)",
      "ancho": "Width (cm)",
      "alto": "Height (cm)",
      "nota": "Note about the cargo"
    },
    "ayudaCampo": {
      "temperatura": "Between -60 and 40. If you meant -18, check the sign.",
      "imoClase": "Like “3”, “4.1”, “5.2” or “8”.",
      "imoUn": "Four digits, with or without the UN prefix: “1203”.",
      "dimensiones": "In centimetres. All three: with two you cannot decide whether it fits."
    }
  },
  "experiencia": {
    "MARITIMO": "Ocean",
    "AEREO": "Air"
  },
  "dia": {
    "corto": {
      "1": "Mo",
      "2": "Tu",
      "3": "We",
      "4": "Th",
      "5": "Fr",
      "6": "Sa",
      "7": "Su"
    },
    "largo": {
      "1": "Monday",
      "2": "Tuesday",
      "3": "Wednesday",
      "4": "Thursday",
      "5": "Friday",
      "6": "Saturday",
      "7": "Sunday"
    }
  },
  "aereo": {
    "porKg": "/kg",
    "porKgColumna": "Price per kg",
    "sinPrecioPorKg": "Your user does not see costs",
    "escalon": "break {etiqueta}",
    "rangoEntre": "From {desde} to {hasta} kg. The top is excluded: exactly {hasta} kg pays the next break.",
    "rangoDesde": "From {desde} kg.",
    "rangoHasta": "Up to {hasta} kg. The top is excluded.",
    "rangoSinCotas": "No breaks declared.",
    "kg": "kg",
    "pesoTarifable": "Chargeable weight",
    "volumetrico": "Volumetric",
    "manda": {
      "VOLUMETRICO": "Volumetric weight prevails: the cargo weighs {real} kg and the volume gives {volumetrico} kg.",
      "REAL": "Actual weight prevails: {real} kg on the scale against {volumetrico} kg from volume.",
      "EMPATE": "Both come out the same: {real} kg on the scale and {volumetrico} kg from volume."
    },
    "relacion": "Volumetric ratio: {valor} cm³/kg",
    "ruta": "Routing",
    "escala": "stop",
    "sinItinerario": "The rate declares no stops. A direct flight is not assumed: the document simply did not say.",
    "trucking": "By road",
    "alternativas": "The supplier left this point open:",
    "preacarreo": "Pickup is at the declared airport and departure is from {salida}, by road. Transit time already accounts for it.",
    "frecuenciaSinInterpretar": "Not interpreted: read the supplier’s wording.",
    "opera": "operates",
    "noOpera": "does not operate",
    "maxLargo": "Max length (m)",
    "maxAncho": "Max width (m)",
    "maxAlto": "Max height (m)",
    "maxPesoPieza": "Max weight per piece (kg)",
    "noApta": "Not suitable for these pieces",
    "apta": "The declared pieces fit within this rate’s limits.",
    "noComprobable": "Whether the pieces fit could not be checked: they were not declared, or the rate does not give its limits as numbers. Read the supplier’s wording.",
    "incumple": {
      "MEDIDA_EXCEDIDA": "The piece measures {declarado} m and does not fit in any orientation: this rate’s maximum is {limite} m.",
      "PESO_POR_PIEZA_EXCEDIDO": "The average weight per piece is {declarado} kg and this rate’s maximum is {limite} kg."
    },
    "porQueEsePeso": "Why that weight"
  }
}
